import loadable from '@loadable/component';

export const NotFoundPageLoadable = loadable(() => import('./NotFoundPage'), {
  resolveComponent: (module) => module.NotFoundPage,
});
